export enum ArticleGroup {
  General = "ALG",
  Composed = "SAM",
}
